import React from 'react';  // eslint-disable-line

const LargeLoading = () => {
    return (
        <svg id="loader" className="loader" viewBox="0 0 260 260" xmlns="http://www.w3.org/2000/svg">
            <defs>
                <linearGradient id="linear" x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" stopColor="#2962ff" />
                    <stop offset="100%" stopColor="#2962ff" />
                </linearGradient>
            </defs>
            <circle className="circle" cx="130" cy="130" r="65" strokeWidth="10" stroke="url(#linear)" />
        </svg>
    );
};

export default LargeLoading;
